export default __webpack_public_path__ + "static/media/age_group.3d43a63a.png";